function scrollToElement(){
    const easeInCubic = function (t) { return t*t*t };
    const scrollElems = document.getElementsByClassName('smooth-scrolling');
    const scrollToElem = (start, stamp, duration, scrollEndElemTop, startScrollOffset) => {
        const runtime = stamp - start;
        let progress = runtime / duration;
        const ease = easeInCubic(progress);
        progress = Math.min(progress, 1);
        window.scroll(0, startScrollOffset + (scrollEndElemTop * ease));
        if(runtime < duration){
            requestAnimationFrame((timestamp) => {
                const stamp = new Date().getTime();
                scrollToElem(start, stamp, duration, scrollEndElemTop, startScrollOffset);
            })
        }
    }
    for(let i=0; i<scrollElems.length; i++){
        const elem = scrollElems[i];
        elem.addEventListener('click',function(e) {
            e.preventDefault();
            let scrollElemId;
            if(e.target.hasAttribute('href')){
                scrollElemId = e.target.href.split('#')[1];
            }else{
                scrollElemId = e.target.dataset.scroll;
            }
            const scrollEndElem = document.getElementById(scrollElemId);
            const anim = requestAnimationFrame(() => {
                const stamp = new Date().getTime();
                const duration = 1200;
                const start = stamp;
                const startScrollOffset = window.pageYOffset;
                const scrollEndElemTop = scrollEndElem.getBoundingClientRect().top;
                scrollToElem(start, stamp, duration, scrollEndElemTop, startScrollOffset);
            })
        })
    }
}

module.exports = scrollToElement;